<div class="di-etat-facturation" [ngClass]="billDetails.class">
	<strong class="text">{{ billDetails.text }}</strong>
	<lua-bouton-icone *ngIf="billedStatus === 'some'" [iconName]="billDetails.iconeName" [color]="billDetails.iconColor"
		(onClick)="handleButtonClick($event)">
	</lua-bouton-icone>
	<lua-icone *ngIf="billedStatus === 'all'" [iconName]="billDetails.iconeName" [color]="billDetails.iconColor"
		mode="outlined">
	</lua-icone>
</div>